import { createContext, useContext } from 'react';

import type { AttentionResponse } from '@/api/adminClient';

export type AttentionState = {
  /** The last good answer; kept through a failed refresh. */
  attention?: AttentionResponse;
  loading: boolean;
  error?: string;
  refresh: () => void;
};

export const ATTENTION_REFRESH_MS = 60_000;

/** "Needs attention" for platform admins, fetched once by `AttentionProvider` for the sidebar and Home. */
export const AttentionContext = createContext<AttentionState>({ loading: false, refresh: () => undefined });

export function useAttention(): AttentionState {
  return useContext(AttentionContext);
}
